import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getObjectByKeyFromArrayPipe',
})
export class GetObjectByKeyFromArrayPipe implements PipeTransform {
  transform(list: any[], value: any, key: string = ''): any {
    if (!list || !key) return null;
    return list.find((item) => item[key] === value);
  }
}
